import { render, staticRenderFns } from "./Right.vue?vue&type=template&id=4502b085"
import script from "./Right.vue?vue&type=script&lang=js"
export * from "./Right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports